'use strict';

exports.__esModule = true;
exports.default = createAbsintheSocketLink;

var _phoenix = require('phoenix');

var _socket = require('@absinthe/socket');

var AbsintheSocket = _interopRequireWildcard(_socket);

var _socketApolloLink = require('@absinthe/socket-apollo-link');

var _auth = require('../../auth');

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function createAbsintheSocketLink(_ref) {
  var uri = _ref.uri;

  var token = _auth2.default.hasToken();
  return (0, _socketApolloLink.createAbsintheSocketLink)(AbsintheSocket.create(new _phoenix.Socket(uri, {
    params: {
      access_token: token.auth
    }
  })));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/graph-client/link-socket-absinthe.js
// module id = 1135
// module chunks = 0